import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import { withTranslation } from 'react-i18next';
import {
  EmptyContainer,
  Content,
  Title,
  SubTitle,
} from 'components/grid/table/components/empty/styled';

class Empty extends React.Component<any> {
  static propTypes = {
    message: PropTypes.node,
    render: PropTypes.func,
    children: PropTypes.any,
  };

  static defaultProps = {
    render: undefined,
    children: undefined,
    message: undefined,
  };

  render() {
    const { render, children } = this.props;

    const message = this.props.message || (
      <Content>
        <Title>
          {this.props.i18n.t('Sorry, but no records matched your query.')}
        </Title>

        <SubTitle>
          {this.props.i18n.t('Try changing your search parameters.')}
        </SubTitle>
      </Content>
    );

    if (render) {
      return render.call(this);
    }

    return (
      <React.Fragment>
        <EmptyContainer data-type="table-empty-container">
          {children && isFunction(children) ? children() : children}
          {!children && message}
        </EmptyContainer>
      </React.Fragment>
    );
  }
}

export default withTranslation()(Empty);
